module.exports = "../../app/cells/components/campaigns/widgets/hero_video_cell.rb";